<app-barra-consulta *ngIf="!carregando" visible="false" [listagemComFiltros]="getListagemComFiltros()"
  (atualizando)="atualizar($event)" (inserindo)="novo($event)" (definirFiltro)="definirFiltragem()" [exibirNovo]="false"
  [detalhe]="detalhe">
</app-barra-consulta>
<div class="conteudo">
  <app-loading [exibir]="carregando"></app-loading>
  <div *ngIf="!carregando">
    <div class="row mt-2">
    </div>
    <div class="row">
      <div class="col">
        <div class="fieldset mb-2">
          <div class="ml-2">
            <label translate class="legend">{{'rmpv.relatorioAnaliseGeral.defineAnaliseExportadas'}}</label>
            <div class="mt-3 ml-3">
              <input [(ngModel)]="exibirAnaliseVenda" type="checkbox">&nbsp;
              <label translate>{{'rmpv.relatorioAnaliseGeral.analiseVendas'}}</label><br>
              <input [(ngModel)]="exibirAnaliseMargem" type="checkbox">&nbsp;
              <label translate>{{'rmpv.relatorioAnaliseGeral.analiseMargem'}}</label><br>
              <input [(ngModel)]="exibirAnalisePassagem" type="checkbox">&nbsp;
              <label translate>{{'rmpv.relatorioAnaliseGeral.analisePassagens'}}</label><br>
              <input [(ngModel)]="exibirAnaliseEstoque" type="checkbox">&nbsp;
              <label translate>{{'rmpv.relatorioAnaliseGeral.analiseEstoque'}}</label><br>
              <input [(ngModel)]="exibirAnaliseHora" type="checkbox">&nbsp;
              <label translate>{{'rmpv.relatorioAnaliseGeral.analiseHoras'}}</label><br>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div translate class="jumbotron"><i class="fas fa-info-circle fa-lg"></i>&nbsp;
      {{'rmpv.relatorioAnaliseGeral.exportacaoGeral'}}
      <p translate>{{'rmpv.relatorioAnaliseGeral.utilizeTelExportacaoAnalises'}}</p>
      <div class="row">
        <div class="col-2">
          <button class="btn btn-outline-secondary btn-sm mb-2 float-left" (click)="exportarExcel()">
            <em class="fa fa-download fa-xs"></em>
            Export Excel
          </button>
        </div>
        <div class="col-2">
          <button class="btn btn-outline-secondary btn-sm mb-2 float-left"
            (click)="marcas === 'JLR' ? mostrarDialogo() : exportarListExcel()">
            <em class="fa fa-download fa-xs"></em>
            Export List Excel
          </button>
        </div>
      </div>
    </div>
    <p-dialog *ngIf="marcas == 'JLR'" [(visible)]="exibirDialogo" header="Filtros Relatório de Análise Geral"
      [modal]="true" [closable]="false">
      <div style="margin: 0px 0px 22px 0px;">
        <div class="p-fluid">
          <div class="p-grid">
            <div class="p-col-6">
              <div class="p-field">
                <label for="mercado">Mercado</label>
                <p-dropdown id="mercado" optionLabel="descricao" [options]="mercados" [(ngModel)]="filtros.mercado"
                  placeholder="Selecione..." class="custom-dropdown" appendTo="body"></p-dropdown>
              </div>
            </div>
            <div class="p-col-6">
              <div class="p-field">
                <label for="grupoEconomico">Grupo Econômico</label>
                <p-dropdown id="grupoEconomico" optionLabel="descricao" [options]="gruposEconomicos"
                  [(ngModel)]="filtros.grupo_economico" placeholder="Selecione..." class="custom-dropdown"
                  appendTo="body"></p-dropdown>
              </div>
            </div>
            <div class="p-col-6">
              <div class="p-field">
                <label for="regiao">Região</label>
                <p-dropdown id="regiao" optionLabel="descricao" [options]="regioes" [(ngModel)]="filtros.regiao"
                  placeholder="Selecione..." class="custom-dropdown" appendTo="body"></p-dropdown>
              </div>
            </div>
            <div class="p-col-6">
              <div class="p-field">
                <label for="dealer">Dealer</label>
                <p-dropdown id="dealer" optionLabel="descricao" [options]="dealers" [(ngModel)]="filtros.dealer"
                  placeholder="Selecione..." class="custom-dropdown" appendTo="body"></p-dropdown>
              </div>
            </div>
            <div class="p-col-6">
              <div class="p-field">
                <label for="dataInicial">Data Inicial</label>
                <p-calendar id="dataInicial" [(ngModel)]="filtro.dataInicial" view="month" dateFormat="mm/yy"
                  [yearNavigator]="true" [monthNavigator]="true" yearRange="2020:2031"
                  class="custom-calendar-month-year" appendTo="body" [showIcon]="true">
                </p-calendar>

              </div>
            </div>
            <div class="p-col-6">
              <div class="p-field">
                <label for="dataFinal">Data Final</label>
                <p-calendar id="dataFinal" [(ngModel)]="filtro.dataFinal" view="month" dateFormat="mm/yy"
                  [yearNavigator]="true" [monthNavigator]="true" yearRange="2020:2031"
                  class="custom-calendar-month-year" appendTo="body" [showIcon]="true">
                </p-calendar>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ng-template pTemplate="footer">
        <p-button label="Cancelar" icon="pi pi-times" (click)="fecharDialogo()" class="p-button-text"></p-button>
        <p-button label="Exportar Excel" icon="pi pi-file-excel" (click)="aplicarFiltros()"
          class="custom-excel-button "></p-button>
      </ng-template>
    </p-dialog>
    <div *ngIf="isLoading" class="spinner-overlay">
      <p-progressSpinner [style]="{ width: '100px', height: '100px' }"></p-progressSpinner>
    </div>
    <p-toast class="mt-8" position="top-right" key="myKey1"></p-toast>
    <div class=" table-scroll" style="display: none;">
      <div class="container-fluid content mt-4" id="RPTGeralExcel">
        <app-analise-venda-bi01-lista-grid [dados]="dados_bi01" [anoFiltro]="anoFiltro" *ngIf="exibirAnaliseVenda">
        </app-analise-venda-bi01-lista-grid>

        <app-analise-margem-bi02-lista-grid [dados]="dados_bi02" [anoFiltro]="anoFiltro" *ngIf="exibirAnaliseMargem">
        </app-analise-margem-bi02-lista-grid>

        <app-analise-passagem-bi03 [data]="dados_bi03" [definirAno]="definirAno" [filtros]="filtrosPassagem"
          *ngIf="exibirAnalisePassagem">
        </app-analise-passagem-bi03>

        <app-analise-estoque-bi04-lista-grid [dados]="dados_bi04" [anoFiltro]="anoFiltro" *ngIf="exibirAnaliseEstoque">
        </app-analise-estoque-bi04-lista-grid>

        <app-analise-hora-bi05-lista-grid [dados]="dados_bi05" [anoFiltro]="anoFiltro" *ngIf="exibirAnaliseHora">
        </app-analise-hora-bi05-lista-grid>
      </div>
    </div>
  </div>
</div>